module.exports = __webpack_public_path__ + "img/icon-tick-circle.3158d178.svg";